/**
 * AccesorioPage component
 * @returns <AccesorioPage />
 */

// Import required components and hooks
import ItemDetailAccesorio from "../components/ItemDetailAccesorio";
import Breadcrumbs from "../components/Breadcrumbs";
import { useLocation, useParams } from "react-router-dom";
import { useGetAccessoryByIdQuery } from "../redux/apiSlice";
import Loader from "../components/Loader";
import { AnimatePresence } from "framer-motion";

// AccesorioPage component definition
const AccesorioPage = () => {
    // Get the location to use in the Breadcrumbs
    const location = useLocation();

    // Get the accesorioId from the route parameters
    const { accesorioId } = useParams();

    // Fetch the accessory data using the useGetAccessoryByIdQuery hook
    const {
        data: accessoryById,
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useGetAccessoryByIdQuery(accesorioId);

    // Prepare the Breadcrumbs component properties
    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: "..",
                label: location.pathname.split("/")[1]
            },
            {
                link: `../${location.pathname.split("/")[2]}`,
                label: accessoryById?.title
            }
        ],

        btnConfig: {
            tag: "link",
            text: "Volver a todos los accesorios",
            color: "black",
            extraClass: "with-icon",
            hasIcon: true,
            url: "/accesorios"
        }
    }

    // Render the AccesorioPage component
    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}
            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />
                    <ItemDetailAccesorio item={accessoryById} />
                </>
            )}
            {isError && <p>Hubo un error</p>}
        </>
    )
}

// Export the AccesorioPage component
export default AccesorioPage;
